/**
 *
 * @module presentation
 *
 */

import Check from 'check-types';

import Exception from './../exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    nonEmptyString,
    number,
    nonEmptyObject,
    array
} = Check.assert;

/**
 *
 * @class Presentation
 *
 */
export default class Presentation {

    /**
     *
     * @param {Object} options
     * @param {String<SDK.Services.Media.ThumbnailPresentationType>} options.presentationType
     * @param {Number} options.thumbnailCount
     * @param {Number} options.offsetMilliseconds
     * @param {Array<String>} options.paths
     *
     */
    constructor(options = {}) {

        const errorMessage = {
            ctor: `${this.constructor.name}(options)`,
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get presentationType() {
                return `${this.ctor} options.presentationType should be a String with length`;
            },
            get thumbnailCount() {
                return `${this.ctor} options.thumbnailCount should be a Number`;
            },
            get offsetMilliseconds() {
                return `${this.ctor} options.offsetMilliseconds should be a Number`;
            },
            get paths() {
                return `${this.ctor} options.paths should be an Array of Strings with length`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { presentationType, thumbnailCount, offsetMilliseconds, paths } = options;

        nonEmptyString(presentationType, errorMessage.presentationType, InvalidArgumentException);
        number(thumbnailCount, errorMessage.thumbnailCount, InvalidArgumentException);
        number(offsetMilliseconds, errorMessage.offsetMilliseconds, InvalidArgumentException);
        array.of.nonEmptyString(paths, options.paths, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String<SDK.Services.Media.ThumbnailPresentationType>}
         * @note it is entirely possible that the service returns a String that isn't in our enum
         * @desc the presentation type
         *
         */
        this.presentationType = presentationType;

        /**
         *
         * @access public
         * @type {Number}
         * @desc The number of thumbnails available for this presentation
         *
         */
        this.thumbnailCount = thumbnailCount;

        /**
         *
         * @access public
         * @type {Number}
         * @desc The milliseconds offset in the media file for the presentation which these thumbnails represent
         *
         */
        this.offsetMilliseconds = offsetMilliseconds;

        /**
         *
         * @access public
         * @type {Array<String>}
         * @desc List of ordered urls to the spritesheets themselves
         *
         */
        this.paths = paths;

    }

}



// WEBPACK FOOTER //
// ./src/services/media/presentation.js